import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../../../environment/environment';
import { ListRequestDTO, createDefaultListRequest } from '../../../../dto/list-request.dto';
import { ListResponseDTO } from '../../../../dto/list-response.dto';
import { AdviDTO } from '../../../../dto/advi/advi.dto';

export const advisories = (dataSourceService: any) => {
  return {
    name: 'advisories',
    description: 'List of educational path advisories',
    execute: (params?: any): Observable<ListResponseDTO<AdviDTO>> => {
      const request: ListRequestDTO = params?.listRequest || createDefaultListRequest();
      
      
      // Convert ListRequestDTO to query parameters
      const queryParams = new URLSearchParams();
      queryParams.set('page', request.page.toString());
      queryParams.set('pageSize', request.pageSize.toString());
      
      if (request.sortBy) {
        queryParams.set('sortBy', request.sortBy);
      }
      if (request.search) {
        queryParams.set('search', request.search);
      }
      
      const url = `${environment.apiUrl}/advi?${queryParams.toString()}`;
      
      return (dataSourceService.http as HttpClient).get<ListResponseDTO<AdviDTO>>(url).pipe(
        catchError(error => {
          console.error('[Advisories DataSource] Error:', error);
          return of({ data: [], totalCount: 0, page: 1, pageSize: 20, meta: { page: 1, pageSize: 20, totalItems: 0, totalPages: 0 } } as ListResponseDTO<AdviDTO>);
        })
      );
    }
  };
};
